export const SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME = 'side-panel-resize-handle';
export const SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME =
    'side-panel-resize-handle--dragging';
export const SIDE_PANEL_CLASS = 'hb-side-panel';
export const SIDE_PANEL_SCROLLED_CLASS = 'hb-side-panel--scrolled';
